export default function LinkPreview({ og, url }) {
  if (!url) return null;

  const safeOg = og || {};

  const displayUrl = (() => {
    try { return new URL(safeOg.url || url).hostname.replace(/^www\./, ''); }
    catch { return url; }
  })();

  return (
    <a
      className="link-preview"
      href={safeOg.url || url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {safeOg.image && (
        <img
          className="link-preview-image"
          src={safeOg.image}
          alt={safeOg.title || ''}
          loading="lazy"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      )}
      <div className="link-preview-body">
        <div className="link-preview-site">
          {safeOg.favicon && (
            <img
              className="link-preview-favicon"
              src={safeOg.favicon}
              alt=""
              loading="lazy"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          )}
          <span>{safeOg.siteName || displayUrl}</span>
        </div>
        <p className="link-preview-title">{safeOg.title || displayUrl}</p>
        {safeOg.description && (
          <p className="link-preview-description">{safeOg.description}</p>
        )}
      </div>
    </a>
  );
}
